"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEmbeddedNotificationStyles = void 0;
var styles_1 = require("@material-ui/core/styles");
var _colors_1 = require("../../../style/commons/_colors");
exports.useEmbeddedNotificationStyles = (0, styles_1.makeStyles)(function () { return ({
    root: {
        borderRadius: 4,
        color: 'white',
        fontSize: 14,
        width: '100%',
    },
    expandIcon: {
        color: 'white',
        fontSize: 24,
        display: 'flex',
        flexDirection: 'row',
        marginRight: -8,
    },
    summary: {
        minHeight: 40,
        paddingLeft: 8,
        paddingRight: 8,
        alignItems: 'flex-start',
        '&$summaryExpanded': {
            minHeight: 40,
        },
    },
    summaryContent: {
        alignSelf: 'center',
        '&$summaryExpanded': {
            margin: '12px 0',
        },
    },
    summaryExpanded: {},
    titleRow: {
        display: 'flex',
        borderRadius: 4,
        flexDirection: 'row',
    },
    icon: {
        display: 'flex',
        flexDirection: 'row',
    },
    title: {
        display: 'flex',
        flexDirection: 'row',
        paddingLeft: 4,
        fontWeight: 500,
        lineHeight: 1.29,
        minWidth: 146,
        '& p': {
            fontWeight: 500,
        },
    },
    details: {
        lineHeight: 1.43,
        paddingTop: 0,
        paddingLeft: 12,
        paddingBottom: 8,
        paddingRight: 8,
        height: 'auto',
        '& p': {
            fontWeight: 'normal',
        },
    },
    success: {
        backgroundColor: _colors_1.lightSuccess,
        color: _colors_1.darkSecondary,
    },
    information: {
        backgroundColor: _colors_1.lightInfo,
        color: _colors_1.darkSecondary,
        fontSize: 16,
    },
    warning: {
        backgroundColor: _colors_1.lightWarning,
        color: _colors_1.darkSecondary,
    },
    error: {
        backgroundColor: _colors_1.lightDanger,
        color: _colors_1.darkSecondary,
    },
    iconExpand: {
        color: "".concat(_colors_1.brandPrimaryMaxDark, " !important"),
        fontSize: '24px !important',
    },
}); });
